function checkWords(sentence, notInclude, isInclude) {
  // Check if all words from notInclude are not in the sentence
  const notIncludeCheck = notInclude.every(
    word => !new RegExp(`\\b${word}\\b`, 'i').test(sentence)
  );

  // Check if any word from isInclude is in the sentence
  const isIncludeCheck = isInclude.some(word =>
    new RegExp(`\\b${word}\\b`, 'i').test(sentence)
  );

  console.table({
    sentence,
    notInclude,
    isInclude,
    notIncludeCheck,
    isIncludeCheck
  });

  // Return true if both checks pass, otherwise return false
  return notIncludeCheck && isIncludeCheck;
}

const dataModal = [
  {
    id: '1',
    value: '',
    accessKey: 'gate_pass_no',
    label: 'Gate Pass No.',
    type: 'OTHER',
    labelInclude: 'Pass No'
  },
  {
    id: '2',
    value: '',
    accessKey: 'vehicle_no',
    label: 'Vehicle Number',
    type: 'OTHER',
    labelInclude: 'Vehicle'
  },
  {
    id: '3',
    accessKey: 'transporter',
    value: '',
    label: 'Transporter',
    type: 'OTHER',
    labelInclude: 'Transporter'
  },
  {
    id: '4',
    accessKey: 'challan_no',
    value: '',
    label: 'Challan No.',
    type: 'OTHER',
    labelInclude: 'Challan No'
  },
  {
    id: '5',
    accessKey: 'driver_name',
    value: '',
    label: 'Driver Name',
    type: 'OTHER',
    labelInclude: 'Driver Name'
  },
  {
    id: '6',
    accessKey: 'gross_weight',
    value: '',
    label: 'Gross Weight',
    type: 'OTHER',
    labelInclude: 'Gross Weight'
  },
  {
    id: '7',
    accessKey: 'gross_time',
    value: '',
    label: 'Gross Time',
    type: 'OTHER',
    labelInclude: 'Gross Time'
  },
  {
    id: '8',
    accessKey: 'tare_weight',
    value: '',
    label: 'Tare Weight',
    type: 'OTHER',
    labelInclude: 'Tare Weight'
  },
  {
    id: '9',
    accessKey: 'tare_time',
    value: '',
    label: 'Tare Time',
    type: 'OTHER',
    labelInclude: 'Tare Time'
  },
  {
    id: '10',
    accessKey: 'net_weight',
    value: '',
    label: 'Net Weight',
    type: 'OTHER',
    labelInclude: 'Net Weight'
  },
  {
    id: '11',
    accessKey: 'exit_time',
    value: '',
    label: 'Exit Time',
    type: 'OTHER',
    labelInclude: 'Exit Time'
  }
];

export function filterFlyAshData(billData) {
  const typeData = {};
  let taxCount = 1;

  //Demo- print all data in console
  let sampleData = [];
  billData?.[0]?.['SummaryFields'].map(invoice => {
    let data = {};
    data['GroupProperties'] = invoice?.GroupProperties?.[0]?.Types?.[0];
    data['LabelDetection'] = invoice?.LabelDetection?.Text;
    data['Type'] = invoice?.Type?.['Text'];
    data['ValueDetection'] = invoice?.ValueDetection?.['Text'];

    sampleData.push(data);
  });

  console.table(sampleData);
  //Demo- print all data in console

  const formingData = dataModal?.map(item => {
    let copyItem = { ...item };

    const findObj = billData?.[0]?.['SummaryFields'].find(bill => {
      if (item.labelNotInclude) {
        if (bill?.Type?.Text === item.type) {
          if (bill?.LabelDetection?.Text) {
            if (
              checkWords(
                (bill?.LabelDetection?.Text || '').toLowerCase(),
                [...item.labelNotInclude],
                [item.labelInclude]
              )
            ) {
              copyItem['value'] = bill?.ValueDetection?.Text;
              copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

              return true;
            }
          } else {
            copyItem['value'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;
          }
        }
      } else if (item.labelInclude) {
        if (
          bill?.Type?.Text === item.type &&
          bill?.LabelDetection?.Text?.toLowerCase()?.includes(
            item.labelInclude?.toLowerCase()
          )
        ) {
          copyItem['value'] = bill?.ValueDetection?.Text;
          copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

          return true;
        }
      } else if (bill?.Type?.Text === item.type) {
        copyItem['value'] = bill?.ValueDetection?.Text;
        copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

        return true;
      } else {
        copyItem['value'] = '';
        copyItem['accuracy'] = 0;

        return false;
      }
    });
    console.log('🚀 ~ findObj ~ findObj:', findObj);

    if (item.secondTry && copyItem?.value?.length === 0) {
      billData?.[0]?.['SummaryFields'].find(bill => {
        if (bill?.Type?.Text === item.type) {
          if (bill?.ValueDetection?.Text?.length > 0) {
            copyItem['value'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

            return true;
          }
        }
      });
    }

    if (copyItem.type === 'TAX') {
      typeData[`${copyItem.type}${taxCount}`] = copyItem;
      taxCount++;
    } else {
      typeData[copyItem.accessKey] = copyItem;
    }

    return copyItem;
  });

  console.log('🚀 ~ formingData ~ formingData:', formingData);

  return {
    filteredData: billData?.length > 0 ? typeData : {},
    data: billData
  };
}
